import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../types/common.types';

import { useMemberBadgeApi } from '../../api/member/badges/useMemberBadgeApi';

import Badges from '../../components/common/Badges/Badges';

type Props = {
  memberReference?: string;
  badgeReferences: string[];
};

const BadgesContainer = ({ memberReference, badgeReferences }: Props) => {
  const { memberBadges = [] } = useSelector((state: RootState) => state.member || {});

  const { viewMemberBadges } = useMemberBadgeApi();

  if (!memberReference) return null;

  const retrieveBadges = (onSuccess: () => void) => {
    viewMemberBadges({ memberExternalReference: memberReference }, onSuccess);
  };

  return <Badges badges={memberBadges} badgeReferences={badgeReferences} retrieveBadges={retrieveBadges} />;
};

export default BadgesContainer;
